angular.module("ainapp")
    .controller("FavouriteCategoriesController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {


            $scope.PageName = "Favourite Categories";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }


            $scope.Init = function () {
                $scope.FavouriteCategory = {
                    Name: "",
                    Icon: "",
                    UserId: $scope.TokenInfo.UserId,


                }

                $scope.load = false;
                $scope.myImage = '';
            }
            $scope.Init();

            $scope.selectIcon = function (e) {
                $scope.FavouriteCategory.Icon = e.Path;
            }

            $scope.KendoSource = new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function (o) {
                        MainService.FavouriteCategoryInView(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error("Network Error");
                        })
                    },

                },
                change: function (data) {},
                schema: {
                    data: "Data",
                    total: "Total",
                    model: {
                        id: "Id",
                        fields: {
                            Name: {
                                type: "text",
                                editable: false,
                            },
                            Icon: {
                                type: "text",
                                editable: false,
                            },

                        }
                    }
                },
                serverPaging: true,
                serverSorting: true,
                pageSize: 10,
            });

            $scope.KendoGridOptions = {
                editable: true,
                pageable: true,
                height: 600,
                resizable: true,
                dataSource: $scope.KendoSource,
                pageSize: 10,
                sortable: true,
                scrollable: true,
                filterable: true,
                groupable: false,
                columns: [
                    {
                        field: "Name",
                        title: "Name",
                        headerTemplate: "{{LanguageData.Name}}",
                            },

                    {
                        field: "Icon",
                        title: "Icon",
                        template: "<img class='iconimg'  src='/{{dataItem.Icon}}' >"
                        },
                    {
                        title: "Options",

                        headerTemplate: "{{LanguageData.Options}}",
                        template: "<button class=' btn-default btn-sm fa fa-trash'  ng-click='DeleteAccType(dataItem)'> </button> <button class='btn-default btn-sm fa fa-pencil' ng-click='Edit(dataItem)'> </button>",
                        width: '220px'
                            },
                        ],
            };



            $scope.SelectedDataForDelete = {};
            $scope.DeleteAccType = function (data) {
                $scope.SelectedDataForDelete = data;
                $("#deleteModal").modal("show");
            }

            $scope.deleteWithConfirm = function () {
                MainService.DeleteFavouriteCategory($scope.SelectedDataForDelete.Id).then(function (response) {
                    if (response.data) {
                        $('#deleteModal').modal('hide');
                        toastr.success("Deleted");
                        $("#Kendo-Grid").data("kendoGrid").dataSource.read();
                        $scope.SelectedDataForDelete = {};
                    }
                })
            }

            $scope.Edit = function (data) {
                $scope.FavouriteCategory = data;
            }


            $scope.AddData = function () {
                if ($scope.FavouriteCategory.Name == "") {
                    toastr.warning("Enter Name");
                } else if ($scope.FavouriteCategory.Icon == "") {
                    toastr.warning("Select Icon");
                } else {
                    $scope.load = true;
                    MainService.AddFavouriteCategory($scope.FavouriteCategory).then(function (response) {
                        if (response.data) {
                            $("#Kendo-Grid").data("kendoGrid").dataSource.read();
                            toastr.success("Success");
                            $scope.Init();
                        } else {
                            toastr.error("Error");
                        }
                        $scope.load = false;
                    }, function (err) {
                        toastr.error("Network Error");
                        $scope.load = false;
                    });
                }
            }


            }]);
